/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MensesEvent from './menses-event';
import MensesEventDetail from './menses-event-detail';
import MensesEventUpdate from './menses-event-update';
import MensesEventDeleteDialog from './menses-event-delete-dialog';

const MensesEventRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MensesEvent />} />
    <Route path="new" element={<MensesEventUpdate />} />
    <Route path=":id">
      <Route index element={<MensesEventDetail />} />
      <Route path="edit" element={<MensesEventUpdate />} />
      <Route path="delete" element={<MensesEventDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MensesEventRoutes;
